import { combineReducers } from 'redux';

const defaultdownloadParams = {
    datafetched: 'waiting'
}

function params(state = defaultdownloadParams, action) {
    if (action.type === 'FETCH_DOWNLOAD_REPORTS') {
        return {
            ...state,
            datafetched: 'pending',
        }
    }
    if (action.type === 'FETCHED_DOWNLOAD_REPORTS') {
        return {
            ...state,
            datafetched: 'success',
        }
    }
    if (action.type === 'FETCH_DOWNLOAD_DATA_WC_WI') {
        return {
            ...state,
            datafetched: 'pending',
        }
    }
    if (action.type === 'FETCHED_DOWNLOAD_DATA_WC_WI') {
        return {
            ...state,
            datafetched: 'success',
        }
    }
    if (action.type === 'FETCH_DOWNLOAD_RECONCILIATION') {
        return {
            ...state,
            datafetched: 'pending',
        }
    }
    if (action.type === 'FETCHED_DOWNLOAD_RECONCILIATION') {
        return {
            ...state,
            datafetched: 'success',
        }
    }
    if (action.type === 'FETCH_DOWNLOAD_DMS_TO_RLB_POST') {
        return {
            ...state,
            datafetched: 'pending',
        }
    }
    if (action.type === 'FETCHED_DOWNLOAD_DMS_TO_RLB_POST') {
        return {
            ...state,
            datafetched: 'success',
        }
    }
    if (action.type === 'RESET_DATA') {
        return defaultdownloadParams
    } else {
        return state
    }
}



const reportsDownload = combineReducers({
    params,
    
});

export default reportsDownload;